import {Vector3} from "three";

export default class POI {
    mousePosO = [0,0];
    mousePosIn = [0,0];
    glApp = false;

    selectionMaterials = [];
    selectableObjects = [];

    textObjects = new Map();

    selectedObject = false;

    curAnim = false;

    constructor(glApp) {
        this.glApp = glApp;
        window.addEventListener('pointerdown', (event) => {
            this.mousePosIn = [event.clientX, event.clientY]
            this.mousePosO = [event.clientX, event.clientY]
        });

        window.addEventListener('pointermove', (event) => {
            this.mousePosO = [event.clientX, event.clientY]
            this.onPointerMove(event);
        });

        glApp.renderer.domElement.addEventListener('pointerup', this.onPointerUp.bind(this));
    }

    selectObject(cubeName) {
        this.glApp.onZoomIn();

        const vec = new Vector3();

        const cube = this.glApp.scene.getObjectByName(cubeName);

        // compute bounding box of geometry
        cube.geometry.computeBoundingBox();

        // get it's center
        cube.geometry.boundingBox.getCenter(vec);

        // convert local to world
        cube.localToWorld(vec);

        this.selectedObject = cube;

        // callback select
        this.glApp.callbackFn('poi_select', {
            name: cube.name
        });

        // if there is already animation, stop it and start new one
        if (this.curAnim) {
            this.curAnim.stop();
        }

        // change orbit target with animation to desired cube
        this.curAnim = animate({
            from: Object.assign(this.glApp.orbit.target, { t: this.glApp.camera.zoom }),

            duration: 500,

            // TODO: calculate zoom
            to: {
                x: vec.x,
                // offset a bit
                y: vec.y - vec.y * 0.2,
                z: vec.z,
                t: this.glApp.isMobile ? 2.5 : 2
            },

            onUpdate: (t) => {
                this.glApp.orbit.target.set(t.x, t.y, t.z);
                this.glApp.camera.zoom = t.t;
                this.glApp.camera.updateProjectionMatrix();
            }
        })
    }

    onPointerMove() {
        const bounds = this.glApp.renderer.domElement.getBoundingClientRect();
        this.glApp.pointerManager.updatePointerPosition(
            event.clientX,
            event.clientY,
            bounds.width,
            bounds.height,
            bounds.left,
            bounds.top,
        )

        // update raycaster
        this.glApp.raycaster.setFromCamera(this.glApp.pointerManager.position.canvasNormalized, this.glApp.camera);
        // raycast
        const intersects = this.glApp.raycaster.intersectObjects(this.selectableObjects);

        if (intersects[0] && intersects[0].object && intersects[0].object.name.indexOf('Cube_') === 0) {
            const group_ = this.glApp.groupByCube.get(this.glApp.cubeByRaycastCube.get(intersects[0].object))
            this.glApp.groups.forEach(group => {
                if (group_ === group) {
                    group.isHovered = true;
                } else {
                    group.isHovered = false;
                }
            });

            document.body.style.cursor = 'pointer';
        } else {
            document.body.style.cursor = null;
            this.glApp.groups.forEach(group => group.isHovered = false);
        }
    }

    onPointerUp(event) {
        // detect if it's not orbit changing
        if (
            Math.abs(this.mousePosIn[0] - this.mousePosO[0]) > 3
            || Math.abs(this.mousePosIn[1] - this.mousePosO[1]) > 3
        ) return;
        // update pointer screen position
        const bounds = this.glApp.renderer.domElement.getBoundingClientRect();
        this.glApp.pointerManager.updatePointerPosition(
            event.clientX,
            event.clientY,
            bounds.width,
            bounds.height,
            bounds.left,
            bounds.top,
        )

        // update raycaster
        this.glApp.raycaster.setFromCamera(this.glApp.pointerManager.position.canvasNormalized, this.glApp.camera);
        // raycast
        const intersects = this.glApp.raycaster.intersectObjects(this.selectableObjects);

        // if there is intersection with Cube_#### (transparent cubes)
        if (intersects[0] && intersects[0].object.name.indexOf('Cube_') === 0) {
            this.selectObject(this.glApp.cubeByRaycastCube.get(intersects[0].object).name);
        }
    }
}